import { makeStyles } from '@mui/styles';

export const layoutStyles = makeStyles(({ palette, ...theme }) => ({
  "@global": {},
}));
